import { FEEDBACK_SURVEY_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const FeedbackSurvey = ObjectDefinitionRecord({
  hasAccess: (_, hasScope) => hasScope('service-feedback-access'),
  objectTypeId: FEEDBACK_SURVEY_ID,
  referenceObjectType: 'FEEDBACK_SURVEY_PROPERTIES'
});
export default FeedbackSurvey;